<template>
	<div id="wrapper">
		<div id="main">
      <!--<p><router-link to="/" class="body-2 font-weight-bold"> <span class="mr-05 icon solid fa-chevron-left primary-color"></span>zurück zur Übersicht</router-link></p>-->
      <article v-if="shop" class="post pt-1">
        <RTDonateList class="mb-3" :stream_id="id" :project="featuredProject" :preview="true" :show_total_donations="!isExternalShop(shop)" :enableStreamNameOption="!isExternalShop(shop)" :limit="shop.limit" :emailRequired="shop.limit >=0"/>

        <!-- passwort eingabe -->
        <!--
        <WSCodeEntry :stream="shop" stream_id="usa-wunder-im-suedwesten" :codelist="codeNeuseeland" vimeo="https://player.vimeo.com/video/547823401" chat="https://vimeo.com/live-chat/547823401/26a26ee457" />
        <WSCodeEntry :stream="shop" stream_id="leaving-home-auf-dem-landweg-nach-new-york" :codelist="codeleavingHome" vimeo="https://player.vimeo.com/video/547823944" chat="https://vimeo.com/live-chat/547823944/7ff5382631" />
        -->
        
        <header class="major">
          <span class="date">{{getFormatedDate(shop.date)}}</span>
          <h1>{{shop.title}}</h1>
          <p>{{shop.author}}</p>
          <p>{{shop.teaser}}</p>
        </header>
        <p v-if="isExternalShop(shop)" class="text-center font-size-2">Live vom Weltsichten Festival<br/>{{getFormatedDate(shop.date,shop.duration)}}</p>
        <p v-else class="text-center font-size-2"><router-link to="/live" class="image fit">Livestream<br/>{{getFormatedDate(shop.date,shop.duration)}}</router-link></p>
        

        <RTStreamIncludingCountdown :stream="shop" disableLink :showStreamLinks="!isExternalShop(shop)">

        </RTStreamIncludingCountdown>
        <!--<div class="image main"><img alt="Stream Cover" :src="shop.cover" /></div>-->
        <RTProjectGallery id="stream-view" class="mt-2" :images="shop.pics" /><!-- :cover="shop.cover"-->
        <p v-if="isExternalShop(shop)">Dieser Stream ist ein Livestream des Weltsichten Festivals. 100 Ticktes sind für das Zuschauen von zu Hause aus freigegeben und können ab einer Mindestspende von 15 € freigeschalten werden. Wie immer bei sofareisen kommt der Erlös zu 100% in den Projekten an.</p>
        <p v-html="shop.descr"></p>
        <p v-if="shop.video" >
          <iframe style="margin:auto;display:block;" :width="getMaxWidthOfPlayer()" :height="getHeightOfPlayer()"  :src="shop.video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </p>
        <p v-if="featuredProject" class="pulseButton">Alle Spenden dieses Vortrags kommen dem {{featuredProject.is_association?"":"Projekt"}} <b>"{{featuredProject.title}}"</b> zu Gute. {{featuredProject.additional}}</p>
        <!-- Donate form -->
        <RTProjectDonation  v-if="featuredProject" class="separator-line" :project="featuredProject" :stream_id="shop.id" :enableStreamNameOption="!isExternalShop(shop)"  :preview="false" :show_text="false" :show_descr="true" :show_redirect="!featuredProject.is_association" :show_total_donations="!featuredProject.is_association" :limit="shop.limit"/>

        <!-- Anmelden für updates -->
        <RTNewsletter v-if="shop.preorder" :stream_id="shop.id">
          <template #label><center>Zugang zum Live-Vortrag</center></template>
          <template #text>
                Du möchtest spenden? Wir schreiben Dich an. <br>Trage hier deine E-Mail-Adresse ein, damit wir Dich benachrichten können.
          </template>
          <template #success><center>Vielen Dank. Wir benachrichtigen Dich, versprochen :-)</center></template>
        </RTNewsletter>

        <!-- Kontakt -->
        <section v-if="referent">
          <h2 class="separator-line">Kontakt</h2>
          <div class="row">
            <div class="col-6 col-12-small pb-1 pt-1" >
              <RTReferentContact :person="referent"/>
            </div>
            <div class="col-6 col-12-small">
              <RTAvatar :img="shop.avatar"  size="170px" style="margin:auto"/>
            </div>
          </div>
        </section>
      </article>
      <article v-else>Dieser Eintrag können wir leider nicht finden</article>
		</div>

  </div>
</template>

<script>

//import RTMap from '@/components/RTMap.vue'
import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'
import {projectBase} from '@/mixins/projectBase.js'
import {referentenBase} from '@/mixins/referentenBase.js'
import RTProjectDonation from '@/components/RTProjectDonation.vue'
import RTDonateList from '@/components/RTDonateList.vue'
import RTReferentContact from '@/components/RTReferentContact.vue'
import RTStreamIncludingCountdown from '@/components/RTStreamIncludingCountdown.vue'
import RTProjectGallery from '@/components/RTProjectGallery.vue'
import RTAvatar from '@/components/RTAvatar.vue'
import RTNewsletter from '@/components/RTNewsletter.vue'
//import WSCodeEntry from '@/components/weltsichten/WSCodeEntry.vue'

export default {
  name: 'StreamView',
  mixins:[helper,shopBase,projectBase,referentenBase],
  components: {
    RTDonateList,
    RTProjectDonation,
    RTReferentContact,
    RTAvatar,
    RTProjectGallery,
    RTStreamIncludingCountdown,
    RTNewsletter
  },
  props:['id'],
  data: function() {
    return {
      shop:null,
      codeleavingHome:""
    };
  },
  watch:{
    isLoading(v){
      if(!v && this.shop==null){
        this.iniShop();
      }
    }
  },
  computed:{
    featuredProject(){
      return (this.shop)?this.getProjectById(this.shop.project_id):null;
    },
    referent(){
      return (this.shop)?this.getReferentenById(this.shop.referent_id):null;
    },
    isLoading(){
			return this.$store.state.shops.isLoading;
    }
  },
  methods:{

    iniShop(){
      this.shop=this.getShopById(this.id);
    },
    getMaxWidthOfPlayer(){
      //screenWidth() -> einbauen
      return this.isSmallTouchDevice()?300:640;
    },
    getHeightOfPlayer(){
      return this.isSmallTouchDevice()?200:360;
    }
  },
  
  beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},0);
		});
  },
  created() {
    this.iniShop();
  },
  destroyed() {
    this.shop=null;
  },
};
</script>

<style scoped type='text/css'>
.cover{
  max-width: 100%;
  max-height: 400px;
}
</style>